import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { AssignmentTurnedIn, Class as ClassIcon, MenuBook, EventAvailable } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink } from 'react-router-dom';
import { api } from '../../../shared/api';
import { useAuthStore } from '../../../features/auth/store';
import PageHeader from '../../../shared/PageHeader';

export default function TeacherDashboard() {
  const user = useAuthStore((s) => s.user);
  const { data } = useQuery({ queryKey: ['teacher-dashboard'], queryFn: async () => (await api.get('/dashboard/teacher')).data });

  return (
    <Box>
      <PageHeader title={`Hi, ${user?.fullName.split(' ')[0]}`} subtitle="Your teaching summary." />
      <Grid container spacing={2}>
        <Stat icon={<ClassIcon />} color="#1E3A8A" label="Classes" value={data?.classesCount ?? 0} link="/portal/marks" />
        <Stat icon={<MenuBook />} color="#10B981" label="Subjects" value={data?.subjectsCount ?? 0} link="/portal/marks" />
        <Stat icon={<AssignmentTurnedIn />} color="#F59E0B" label="Pending mark drafts" value={data?.pendingMarks ?? 0} link="/portal/marks" />
        <Stat icon={<EventAvailable />} color="#0EA5E9" label="Assessments created" value={data?.assessmentsCount ?? 0} link="/portal/assessments" />

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Quick actions</Typography>
              <Grid container spacing={2}>
                <ActionCard title="Mark Attendance" body="Record today's attendance for your class." link="/portal/attendance" />
                <ActionCard title="Enter Marks" body="Update marks for your assigned subjects." link="/portal/marks" />
                <ActionCard title="Create Assessment" body="Assign new homework or tests." link="/portal/assessments" />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

function Stat({ icon, color, label, value, link }: any) {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card component={RouterLink} to={link} sx={{ textDecoration: 'none', display: 'block' }}>
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box sx={{ color, bgcolor: `${color}10`, p: 1, borderRadius: 2 }}>{icon}</Box>
            <Box>
              <Typography variant="overline" color="text.secondary">{label}</Typography>
              <Typography variant="h4" sx={{ fontWeight: 800 }}>{value}</Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
}

function ActionCard({ title, body, link }: any) {
  return (
    <Grid item xs={12} sm={4}>
      <Card component={RouterLink} to={link} sx={{ textDecoration: 'none', display: 'block', height: '100%' }}>
        <CardContent>
          <Typography sx={{ fontWeight: 700 }}>{title}</Typography>
          <Typography variant="body2" color="text.secondary">{body}</Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
